import React, { type ComponentPropsWithoutRef } from 'react';

const ConditionalProfileCard = importCond<
	typeof import('./index.tsx'),
	typeof import('./async.tsx')
>('empanada_profilecard_trial_sync_trigger_import', './index.tsx', './async.tsx');

// inline this into usages when cleaning up empanada_profilecard_trial_sync_trigger_import
export default function ProfileCard(
	props: ComponentPropsWithoutRef<typeof ConditionalProfileCard>,
) {
	return <ConditionalProfileCard {...props} />;
}
